import { UIRadioButton } from "components/ui/form/UIRadioButton";
import UIButton from "components/ui/form/UIButton";
import { useEffect, useRef, useState } from "react";
import UISelect from "components/ui/select/UISelect";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { CalendarMonth } from "@mui/icons-material";
import UITimePicker from "components/datepicker/UITimePicker";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { Button, TextField } from "@mui/material";
import _ from "lodash";
import { GET_PATIENT, IS_TELEHEALTH_ENABLED, SCHEDULE_APPOINTMENT, UPDATE_PATIENT } from "adapters/ehr.service";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { USA_STATE_CODE_TO_TIME_ZONE } from "config/helpers/timezone_helper";
import  tz  from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
dayjs.extend(tz)
dayjs.extend(utc)

const ScheduleAppointmentRightDrawer = (props) => {

  const { i18n } = useTranslation()
  const { setOpen, appointmentState , setEvents} = props;
  const { control, handleSubmit, formState: { errors }, setValue, watch, getValues } = useForm();

  const [scheduleAppointmentState, setScheduleAppointmentState] = useState({
    telehealth: 'no',
  });
  const [patient, setPatient] = useState();
  const [patientResponse, setPatientResponse] = useState();
  const [patientOptionList, setPatientOptionList] = useState();
  const [loading, setLoading] = useState(false);
  const [isTelehealthEnabled, setIsTelehealthEnabled] = useState(false);

  const auth = useSelector(state => state?.auth);
  const navigate = useNavigate()

  const handleOnClick = () => {
     setOpen(false)
     setEvents((prevEvents) => {
      return prevEvents?.filter((event) =>event?.id !== "newAppointment" );
    });  }

  const prevSelectedPatientId = useRef();

  const BOOK = i18n.t('common.BOOK')
  const CANCEL = i18n.t('common.CANCEL')


  useEffect(() => {
    const tempPatientList = auth?.relatedPersons?.map((item) => {
      const patientData = {};
      patientData.label = item?.relatedPersonName;
      patientData.value = item?.relatedPersonName;
      patientData.id = item?.patientId;
      patientData.isDisabled = item?.disabled;
      return patientData;
    })
    setPatientOptionList(tempPatientList);

    const selectedPatient = auth.relatedPersons.find(f => f.patientId === auth.activePersonId);
    if (!selectedPatient?.disabled) {
      setValue(
        'patient',
        {
          label: selectedPatient?.relatedPersonName,
          id: selectedPatient?.patientId,
          value: selectedPatient?.relatedPersonName,
        }
      )
      setScheduleAppointmentState({
        ...scheduleAppointmentState,
        patient: {
          label: selectedPatient?.relatedPersonName,
          id: selectedPatient?.patientId,
          value: selectedPatient?.relatedPersonName,
        }
      })
    }
  }, [auth])

  const checkTelehealthAppointment = async (id) => {
    const response = await IS_TELEHEALTH_ENABLED(id)
    setIsTelehealthEnabled(response?.data?.total > 0);
    if(response?.data?.total <= 0){
      setValue('telehealth', 'no');
    }
  }

  useEffect(() => {
    if(props?.appointmentState?.practitioner?.doctorId){
      checkTelehealthAppointment(props?.appointmentState?.practitioner?.doctorId);
    }
  },[props])

    useEffect(()=>{
      if(props?.appointmentState){
        if(appointmentState?.mobileSlots?.selectedSlots?.length){
          const startTimeStr = appointmentState?.mobileSlots?.selectedSlots?.[0]?.split(' - ')?.[0];
          const endTimeStr = appointmentState?.mobileSlots?.selectedSlots?.[appointmentState?.mobileSlots?.selectedSlots?.length - 1]?.split(' - ')?.[1];
          const date = appointmentState?.date;
          // Combine date and time
          const formattetDate = dayjs(date)?.format('YYYY-MM-DD');
          const combinedStartDateTime = dayjs(`${formattetDate} ${startTimeStr}`);
          const combinedEndDateTime = dayjs(`${formattetDate} ${endTimeStr}`);
  
          const formattedStartDateTime = combinedStartDateTime.format("YYYY-MM-DD HH:mm");
          const formattedEndDateTime = combinedEndDateTime.format("YYYY-MM-DD HH:mm");
        
          setValue('startTime',dayjs(formattedStartDateTime))
          setValue('endTime',dayjs(formattedEndDateTime))
          setValue('duration',appointmentState?.mobileSlots?.selectedSlots?.length*15);
        } else {
          setValue('startTime',dayjs(appointmentState?.startTime))
          setValue('endTime',dayjs(appointmentState?.endTime))
          setValue('duration',appointmentState?.duration);
        }
          if(appointmentState?.id){
            const appointmentType = appointmentTypeOptionList?.filter(f => f?.code === appointmentState?.appointmentType?.code)?.[0];
            const appointmentStatus = allAppointmentStatus?.filter(f => f?.value === appointmentState?.status)?.[0];
            
            setValue('appointmentType',appointmentType);
            setValue('appointmentStatus',appointmentStatus);

            setValue('note', appointmentState?.description);
            setValue('telehealth', appointmentState?.isTelehealth ? 'yes' : 'no')
          }
        setValue('practitioner', appointmentState?.practitioner);
        setValue('location',appointmentState?.location);
        if(appointmentState?.id){
          setScheduleAppointmentState({
            ...scheduleAppointmentState,
            id: appointmentState?.id,
          })
        }
      }
      setValue('practitioner', appointmentState?.practitioner);
        if(!props?.appointmentState?.id){
        setValue('appointmentStatus',{ value: 'booked', label: 'Booked' });
      }
    setValue('location', appointmentState?.location);
  }, [props])

  // useEffect(() => {
  //   setScheduleAppointmentState({
  //     ...scheduleAppointmentState,
  //     startTime: startTime,
  //     endTime: endTime,
  //     duration: appointmentState?.selectedSlots?.length*15,
  // })
  // }, [startTime, endTime])

  let appointmentSkeleton = {
    resourceType: "Appointment",
    status: "booked",

    specialty: [
      {
        coding: [
          {
            system: "http://snomed.info/sct",
            code: "394814009",
            display: "General practice",
          },
        ],
      },
    ],
    slot: [],
    reasonCode: [
      {
        coding: [
          {
            system: "http://snomed.info/sct",
            code: "413095006",
          },
        ],
        text: "Clinical Review",
      },
    ],
    description: "Discussion on the results of your recent MRI",
    minutesDuration: 30,
    participant: [],
  };

  useEffect(() => {
    let selectedPatient = watch('patient');

        if (selectedPatient && selectedPatient.id !== prevSelectedPatientId.current || props?.appointmentState?.id) {
          // Update the previous selected patient ID
          prevSelectedPatientId.current = selectedPatient.id;
        
          // Perform the desired actions
          getPatientData(selectedPatient.id);
          setPatient(selectedPatient);
        }

    // setScheduleAppointmentState({
    //   ...scheduleAppointmentState,
    //   patient: watch('patient'),
    // })
  }, [watch('patient')])

  useEffect(() => {
    setScheduleAppointmentState({
      ...scheduleAppointmentState,
      telehealth: watch('telehealth')
    })
  }, [watch('telehealth')])

  const getPatientData = async (patientId) => {
    const patientData = await GET_PATIENT(patientId);

    setPatientResponse(patientData);

    const patientEmail = patientData?.resource?.telecom?.filter(f => f?.system === 'email')?.[0]?.value;

    if (patientEmail) {
      setScheduleAppointmentState({
        ...scheduleAppointmentState,
        patientEmail: patientEmail,
      })
      setValue('patientEmail', patientEmail);
    }

  }

  const updatePatientEmail = async (email) => {

    const payload = { ...patientResponse?.resource };

    const emailObj = payload?.telecom?.filter(f => f?.system === 'email' && f?.use === 'home')?.[0];

    if(emailObj){
      payload?.telecom?.forEach(item =>{
        if(item?.system === 'email' && item?.use === 'home'){
          item.value = email;
          return
        }
      });
    } else {
      payload?.telecom?.push({
        "system": "email",
        "use": "home",
        "value": email,
      })
    }


    setLoading(true);

    const res = await UPDATE_PATIENT(payload);

    setLoading(false);

  }

  const onSubmit = async (data) => {
    const { startTime, endTime } = calculateAppointmentTimes(
             props?.appointmentState?.date,
             data,
             data?.location?.state
            );

    if (data?.telehealth === 'yes' && !scheduleAppointmentState?.patientEmail) {
      try {
        await updatePatientEmail(data?.patientEmail);
      } catch (error) {

        return
      }
    }

    // let startTime = data?.startTime.toISOString();
    // let endTime = data?.endTime.toISOString();

    if (!_.isEmpty(data?.appointmentType)) {
      const appointmentType = {
        coding: [
          {
            system: "http://terminology.hl7.org/CodeSystem/v2-0276",
            code: data?.appointmentType?.code,
            display: data?.appointmentType?.label,
          },
        ],
      };
      appointmentSkeleton.appointmentType = appointmentType;
    }
    let patientOb = {};
    patientOb.actor = {};
    patientOb.actor.reference = "Patient/" + data?.patient?.id;
    patientOb.actor.display = data?.patient?.label;
    patientOb.required = "required";
    patientOb.status = "accepted";
    let doctorObj = {
      actor: {
        reference: `Practitioner/${data?.practitioner?.doctorId}`,
        display: data?.practitioner?.label,
      },
      required: "required",
      status: "accepted",
    };
    let locationObj = {
      actor: {
        reference: `Location/${data?.location?.locationId}`,
        display: data?.location?.label,
      },
      required: "required",
      status: "accepted",
    };
    if (data?.telehealth === 'yes') {
      appointmentSkeleton.serviceType = [
        {
          "coding": [
            {
              "system": "http://enliv.com/appointment/service-type",
              "code": "telehealth"
            }
          ],
          "text": "Enliv Telehealth Appointment"
        }
      ]
      appointmentSkeleton.extension = [
        {
          "url": "http://enliv.com/telehealth/appointment-internal-status",
          "valueString": "queued"
        }
      ]
    }

        let participantCollection = [];
        participantCollection.push(locationObj);
        participantCollection.push(doctorObj);
        participantCollection.push(patientOb);
    
        appointmentSkeleton.participant = participantCollection;
        appointmentSkeleton.start = startTime;
        appointmentSkeleton.end = endTime;
        appointmentSkeleton.description = data?.note;
        appointmentSkeleton.minutesDuration =
        data?.duration + 0;
        appointmentSkeleton.status = data?.appointmentStatus?.value; 
        // if (appointmentStatusState?.appointmentType === "cancelled") {
        // }
        if(props?.appointmentState?.id){
          appointmentSkeleton.id = props?.appointmentState?.id;
        }
        scheduleAppointment(appointmentSkeleton);
      };

      const scheduleAppointment = async (payload) => {
        setLoading(true);
        const response = await SCHEDULE_APPOINTMENT(payload);
        if(response){
          setOpen(false);

          setEvents((prevEvents) => {
            return prevEvents?.filter((event) =>event?.id !== "newAppointment");
          });

          if(payload?.id){
            toast?.success(`${i18n?.t('appointments.APPOINTMENT_RESCHEDULED_SUCCESSFULLY')}`);
          }else{
            toast?.success(`${i18n?.t('appointments.APPOINTMENT_SCHEDULED_SUCCESSFULLY')}`);
          }
          navigate(`/appointments/details?id=${response?.data?.id}`,{
            state:{
              booking: !payload?.id,
              reschedule: payload?.id,
            }
          })
        }
        setLoading(false);
      }

      const allAppointmentStatus = [
        { value: 'proposed', label:`${i18n.t('appointments.PROPOSED')}` },
        { value: 'booked', label: `${i18n.t('appointments.BOOKED')}` },
        { value: 'fulfilled', label: `${i18n.t('appointments.FULFILLED')}` },
        // { value: 'cancelled', label: 'Cancelled' },
        { value: 'pending', label: `${i18n.t('appointments.PENDIND')}` },
        { value: 'arrived', label: `${i18n.t('appointments.ARRIVED')}` },
        { value: 'noshow', label: `${i18n.t('appointments.NOSHOW')}` },
        { value: 'entered-in-error', label: `${i18n.t('appointments.ENTERED_IN_ERROR')}` },
        { value: 'checked-in', label: `${i18n.t('appointments.CHECKED_IN')}`},
        { value: 'waitlist', label: `${i18n.t('appointments.WAITLIST')}`},
    ];
    
    const appointmentStatusWhileCreate = [
        { value: 'proposed', label: `${i18n.t('appointments.PROPOSED')}`},
        { value: 'booked', label: `${i18n.t('appointments.BOOKED')}` },
    ];

  const appointmentTypeOptionList = [
    {
      code: 'CHECKUP',
      value: 'A routine check-up, such as an annual physical',
      label: `${i18n.t('appointments.A_ROUTINE_CHECK_UP_SUCH_AS_AN_ANNUAL_PHYSICAL')}`,
    },
    { code: 'EMERGENCY', value:'Emergency appointment' , label: `${i18n.t('appointments.EMERGENCY_APPOINTMENT')}`, },
    {
      code: 'FOLLOWUP',
      value: 'A follow up visit from a previous appointment',
      label: `${i18n.t('appointments.A_FOLLOW_UP_VISIT_FROM_A_PREVIOUS_APPOINTMENT')}`,
    },
    { code: 'ROUTINE', value: 'Routine appointment', label: `${i18n.t('appointments.ROUTINE_APPOINTMENT')}`,},
    { code: 'WALKIN', value: 'A previously unscheduled walk-in visit', label:`${i18n.t('appointments.A_PREVIOUSLY_UNSCHEDULED_WALK_IN_VISIT')}`, },
  ];

  
  const leftTime = (start , end) => {
    const startTime = dayjs(start);
    const endTime = dayjs(end);
    const durationInMinutes = endTime.diff(startTime, 'minute');
    const durationHours = Math.floor(durationInMinutes / 60);
    const durationMinutes = durationInMinutes % 60;
    console.log('durationHours---',durationHours)
    return `${durationHours ? durationHours + i18n?.t('common.HOUR') : ''} ${durationMinutes ? durationMinutes + i18n?.t('common.MINUTES') : ''}`
  }
 

    return(
        <>
            {/* <div className="d-flex flex-column justify-content-between" style={{height:'95vh'}}> */}
            <form onSubmit={handleSubmit(onSubmit)}>
              <div  className="d-flex flex-column " style={{ height: '100vh' }}>
                <div className={`overflow-auto hide-scrollbar `} style={{ flex: '1 1 auto' }}>
                    <div className='pt-2'>
                        <ArrowForwardIosIcon className="c-pointer" onClick={handleOnClick} />
                    </div>
                    <div className="my-4 text-primary font-medium b-500">
                       {i18n.t('appointments.FILL_THE_DETAILS_BELOW')}
                    </div>
                        {/* <div className="font-medium d-flex justify-content-between"> */}
                            <div className='text-center font-medium b-500'>{dayjs(appointmentState?.date)?.format("ddd, DD MMM")}</div>
                            {/* <div><CalendarMonth /></div> */}
                        {/* </div> */}
                                   <div className="d-flex flex-column flex-md-row justify-content-between mt-2">
                                     <div className="text-center text-md-left">
                                         <div className="font-medium b-500">{i18n.t('appointments.START_TIME')}</div>
                                          <div className="font-medium">{dayjs(getValues('startTime'))?.format("hh:mm A")}</div>
                                      </div>
                                   <div className="timeline text-center p-4">
                                           <div className="timeline-marker font-medium">
                                            -- {leftTime(getValues('startTime'), getValues('endTime'))} --
                                            </div>
                                    </div>
                                    <div className="text-center text-md-right">
                                     <div className="font-medium b-500">{i18n.t('appointments.END_TIME')}</div>
                                        <div className="font-medium">{dayjs(getValues('endTime'))?.format("hh:mm A")}</div>
                                    </div>                
  
                       {/* <Controller
                                  name="startTime"
                                  control={control}
                                  // defaultValue={startTime}
                                  // rules={{ required: '*Appointment status is required.' }} // Validation rules
                                  render={({ field }) => (
                                    <>
                                     <UITimePicker 
                                        sx={{marginRight: '10px'}}
                                        label='Start Time'
                    value={field?.value}
                    readOnly={true}
                  // onChange={(e)=>{
                  //   field.onChange(e?.target?.value)
                  // }}
                  />
                  {errors.startTime && (
                    <span className="text-danger">{errors?.startTime?.message}</span>
                  )}
                </>
              )}
            />
            <Controller
              name="endTime"
              control={control}
              // defaultValue={endTime}
              // rules={{ required: '*Appointment status is required.' }} // Validation rules
              render={({ field }) => (
                <>
                  <UITimePicker
                                        label='End Time'
                                        sx={{marginRight: '10px'}}
                                        value={field?.value}
                                        readOnly={true}
                                        // onChange={(e)=>{
                                        //   field.onChange(e?.target?.value)
                                        // }}
                                    />
                                      {errors.endTime && (
                                        <span className="text-danger">{errors?.endTime?.message}</span>
                                      )}
                                    </>
                                  )}
                                /> */}
                                {/* <UITimePicker 
                                    sx={{marginRight: '10px'}}
                                    value={startTime}
                                    readOnly={true}
                                    // onChange={(e)=>{
                                    //     setStartTime(e?.target?.value)
                                    // }}
                                />
                                <UITimePicker 
                                    sx={{marginLeft: '10px'}}
                                    value={endTime}
                                    readOnly={true}
                                    // onChange={(e)=>{
                                    //     setEndTime(e?.target?.value)
                                    // }}
                                /> */}
                        </div>
                        <div className="my-3">
                          <Controller
                            name="appointmentStatus"
                            control={control}
                            defaultValue=""
                            rules={{ required: '*Appointment status is required' }} // Validation rules
                            render={({ field }) => (
                              <>
                                <UISelect
                                  required
                                  placeholder={i18n.t('appointments.APPOINTMENT_STATUS')}
                                  label={i18n.t('appointments.APPOINTMENT_STATUS')}
                                  size="medium"
                                  // options={props?.appointmentState?.id ? allAppointmentStatus :appointmentStatusWhileCreate}
                                  options={appointmentStatusWhileCreate}
                                  onChange={(value) => field.onChange(value)}
                                  selectedValues={field.value}
                                />
                                {errors.appointmentStatus && (
                                  <span className="text-danger">{errors?.appointmentStatus?.message}</span>
                                )}
                              </>
                            )}
                          />
                        </div>

                        <div className="my-3">
                          <Controller
                            name="appointmentType"
                            control={control}
                            // defaultValue=""
                            // rules={{ required: '*Appointment type is required' }} // Validation rules
                            render={({ field }) => (
                              <>
                                <UISelect
                                  // required
                                  placeholder={i18n.t('appointments.APPOINTMENT_TYPE')}
                                  label={i18n.t('appointments.APPOINTMENT_TYPE')}
                                  size="medium"
                                  options={appointmentTypeOptionList}
                                  onChange={(value) => field.onChange(value)}
                                  selectedValues={field.value}
                                />
                                {errors.appointmentType && (
                                  <span className="text-danger">{errors?.appointmentType?.message}</span>
                                )}
                              </>
                            )}
                          />
                        </div>


                        <div className="my-3">
                          <Controller
                              name="patient"
                              control={control}
                              // defaultValue=""
                              rules={{ required: '*Patient is required' }} // Validation rules
                              render={({ field }) => (
                                <>
                                  <UISelect
                                    required
                                    placeholder={i18n.t('appointments.SELECT_PATIENT')}
                                    label={i18n.t('appointments.SELECT_PATIENT')}
                                    size="medium"
                                    options={patientOptionList}
                                    onChange={(value) => field.onChange(value)}
                                    selectedValues={field.value}
                                    isDisabled={props?.appointmentState?.id}
                                  />
                                  {errors.appointmentType && (
                                    <span className="text-danger">{errors?.patient?.message}</span>
                                  )}
                                </>
                              )}
                            />
                            {/* <UISelect placeholder={'Select Patient'} size={'medium'} options={patientOptionList} onChange={(value) => handleChange(value, 'patient')} selectedValues={scheduleAppointmentState?.patient} /> */}
                        </div>
                        {/* <div className="my-3">
                            <UISelect placeholder={'Gender'} size={'medium'}  options={genderOptionList} onChange={(value) => handleChange(value, 'gender')} selectedValues={scheduleAppointmentState?.gender} />
                        </div> */}
                        <div>
                          {
                            patient && (
                            <>
                              <div className="fs b-600 my-2">
                                 {i18n.t('appointments.TELEHEALTH')}
                              </div>
                              <div className="mb-3">
                              <Controller
                                name="telehealth"
                                control={control}
                                defaultValue='no'
                                rules={{ required: true }}
                                render={({ field }) => (
                                  <>
                                    <UIRadioButton
                                      onChange={(value) => field.onChange(value)}
                                      checked={field.value === 'yes'}
                                      value="yes"
                                      label={i18n.t('common.YES')}
                                      disabled={!isTelehealthEnabled}
                                    />
                                    <UIRadioButton
                                      onChange={(value) => field.onChange(value)}
                                      checked={field.value === 'no'}
                                      value='no'
                                      label={i18n.t('common.NO')}
                                    />
                                  </>
                                )}
                              />
                              {errors.telehealth && (
                                <div className="text-danger">{i18n.t('appointments.TELEHEALTH_IS_REQUIRED')}</div>
                              )}
                              {
                                !isTelehealthEnabled && (
                                  <div className="text-danger">{i18n.t('appointments.TELEHEALTH_NOT_SUPPORTED')}</div>
                                )
                              }

                              </div>
                            </>  
                            )
                          }
                            {
                              scheduleAppointmentState?.telehealth === 'yes' && (
                                <div className="my-3">
                                  <Controller
                                    name="patientEmail"
                                    size='small'
                                    control={control}
                                    // defaultValue={scheduleAppointmentState?.patientEmail}
                                    rules={{ 
                                      required: {
                                        value: scheduleAppointmentState?.telehealth === 'yes',
                                        message: `*${i18n?.t('appointments.EMAIL_IS_REQUIRED')}`,
                                      },
                                      pattern: {
                                        value:  /^\w+([.+]?\w+)*@\w+([.+]?\w+)*(\.\w{2,3})+$/,
                                        message: `*${i18n?.t('appointments.EMAIL_IS_IN_INVALID_FORMAT')}`,
                                      },

                                     }}
                                    render={({field}) => (
                                      <>
                                        <div className="fxs b-500">
                                      {i18n.t('appointments.PATIENT_EMAIL')}
                                          {
                                            scheduleAppointmentState?.telehealth === 'yes' &&
                                            <span className='text-danger b-500' style={{fontSize: '14px'}}>*</span>
                                          }
                                        </div>
                                        <TextField 
                                            // multiline
                                            disabled={scheduleAppointmentState?.patientEmail}
                                            placeholder=  {i18n.t('appointments.PATIENT_EMAIL')}
                                            fullWidth
                                            minRows={8}
                                            value={field?.value}
                                            onChange={(e) => field.onChange(e?.target?.value)}  
                                            error={Boolean(errors?.patientEmail)}
                                        />
                                      </>
                                    )}
                                  />
                                  {errors?.patientEmail && (
                                      <span className="text-danger">{errors?.patientEmail?.message}</span>
                                  )}
                                </div>
                              )
                            }
                            <div>
                            <Controller
                             name="note"
                             control={control}
                             defaultValue=""
                             rules={{ 
                              maxLength: {
                                value: 200,
                                message: '*Maximum Limit of Letters is 200'
                              } 
                            }}
                              render={({field}) => (
                                <>
                                  <div className="fxs b-500">
                                  {i18n.t('appointments.NOTE')}
                                  </div>
                                  <TextField 
                                      multiline
                                      placeholder={i18n.t('appointments.WRITE_A_SHORT_NOTE_ON_YOUR_PROBLEM')}
                                      fullWidth
                                      minRows={8}
                                      spellCheck={true} // Enable spell checking
                                      inputProps={{
                                        autoComplete: 'on', // Enable auto-suggestion
                                      }}
                                      value={field?.value}
                                      onChange={(e) => field.onChange(e?.target?.value)}  
                                      error={Boolean(errors?.note)}
                                  />
                                </>
                              )}
                             />
                             {errors?.note && (
                                <span className="text-danger">{errors?.note?.message}</span>
                              )}
                            </div>
                        </div>
    
                </div>
       <div className=" pt-2 pb-2 ">
          <div className="d-grid gap-2">
            <UIButton loading={loading} text={props?.appointmentState?.id ? `${i18n.t('appointments.RESCHEDULE')}` : `${i18n.t('common.BOOK')}`} fullWidth={true} callback={handleSubmit(onSubmit)} />
            <UIButton text={`${i18n.t('common.CANCEL')}`} backgroundColor='line_red' fullWidth={true} variant={'outlined'} callback={handleOnClick} />
          </div>
        </div>
  

                </div>
            </form> 
            {/* </div> */}
        </>
    )
} 

export default ScheduleAppointmentRightDrawer;

export const calculateAppointmentTimes = (
  selectedDate,
  appointmentStatusState,
  stateCode
) => {
  let dateOnly = dayjs(selectedDate)?.format('YYYY-MM-DD')
  let startTimeOnly = convertTo24HourFormat(dayjs(appointmentStatusState?.startTime).format('hh:mm A'));
  let startTimeInTimeZone = createStateTimeDate(
    dateOnly,
    startTimeOnly,
    stateCode
  );
  let duration = appointmentStatusState?.duration;
  let endTimeInTimeZone = startTimeInTimeZone.add(duration, "minute");
  let startTime = startTimeInTimeZone.utc().toISOString();
  let endTime = endTimeInTimeZone.utc().toISOString();
  return { startTime, endTime };
};

export const convertTo24HourFormat = (time12Hour) => {
  const [time, period] = time12Hour?.split(" ");
  const [hours, minutes] = time.split(":");
  if (period === "PM") {
    if (hours === "12") {
      return `${hours}:${minutes}`;
    } else {
      return `${parseInt(hours) + 12}:${minutes}`;
    }
  } else {
    if (hours === "12") {
      return `00:${minutes}`;
    } else {
      return `${hours}:${minutes}`;
    }
  }
};

const createStateTimeDate = (dateString, time24Hour, stateCode) => {
  const timeZone = USA_STATE_CODE_TO_TIME_ZONE.get(stateCode);
  const [hours, minutes] = time24Hour.split(':').map(Number);

  // Create a Day.js object using the timezone of the state
  let dateWithTimezone = dayjs.tz(dateString, timeZone);
  dateWithTimezone = dateWithTimezone.hour(hours).minute(minutes);

  return dateWithTimezone;
};